(function () {
  var PER_PAGE = 6;

  function bindTagFilter() {
    var select = document.querySelector('#BlogTagFilter');
    if (!select) return;

    var span = document.createElement('span');
    document.body.appendChild(span);

    span.style.cssText =
      'position:absolute;visibility:hidden;white-space:nowrap;font:' +
      getComputedStyle(select).font;

    span.textContent = select.options[select.selectedIndex].text;
    select.style.width = span.offsetWidth + 50 + 'px';
    span.remove();

    select.addEventListener('change', function (e) {
      location.href = e.target.value;
    });
  }

  function getPage() {
    try {
      var n = parseInt(
        new URL(location.href).searchParams.get('blog-page'),
        10
      );

      return n > 0 ? n : 1;
    } catch (e) {
      return 1;
    }
  }

  function setPage(page) {
    try {
      var url = new URL(location.href);

      if (page <= 1) {
        url.searchParams.delete('blog-page');
      } else {
        url.searchParams.set('blog-page', String(page));
      }

      history.replaceState(
        {},
        '',
        url.pathname + url.search + url.hash
      );
    } catch (e) {}
  }

  function setDisabled(el, on) {
    if (!el) return;

    el.classList.toggle('disabled', on);
    el.classList.toggle('enable', !on);
    el.setAttribute('aria-disabled', on ? 'true' : 'false');
  }

  function setArticleVisible(el, visible) {
    if (!el) return;

    el.hidden = !visible;
    el.classList.toggle('hidden', !visible);
    el.classList.toggle('is-blog-page-hidden', !visible);

    if (visible) {
      el.style.removeProperty('display');
    } else {
      el.style.setProperty('display', 'none', 'important');
    }
  }

  function fetchPageArticles(blogUrl, shopifyPage) {
    var url = new URL(blogUrl, location.origin);

    // Keep ?page= here because this is Shopify's native pagination.
    url.searchParams.set('page', String(shopifyPage));

    return fetch(url.pathname + url.search, {
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) {
          throw new Error('fetch page ' + shopifyPage);
        }

        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-blog-articles]');

        if (!list) return [];

        return Array.prototype.slice
          .call(list.querySelectorAll('[data-blog-article]'))
          .filter(function (node) {
            return !isHideFromSearchCard(node);
          });
      });
  }

  function isHideFromSearchCard(node) {
    if (!node) return false;

    var raw = (
      node.getAttribute('data-article-tags') || ''
    ).toLowerCase();

    if (
      raw.indexOf('hide-from-search') !== -1 ||
      raw.indexOf('hide_from_search') !== -1 ||
      raw.indexOf('hide from search') !== -1
    ) {
      return true;
    }

    var markers = node.querySelectorAll(
      'a[href*="/tagged/hide-from-search"], ' +
      'a[href*="/tagged/hide_from_search"]'
    );

    if (markers.length) return true;

    var tags = node.querySelectorAll(
      '.article__grid-tag, .article__tags a'
    );

    for (var i = 0; i < tags.length; i++) {
      var t = (
        tags[i].textContent || ''
      )
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();

      if (
        t === 'hide-from-search' ||
        t === 'hide from search' ||
        t.indexOf('hide-from-search') !== -1 ||
        t.indexOf('hide from search') !== -1
      ) {
        return true;
      }
    }

    return false;
  }

  function loadAllPublicPosts(root) {
    var blogUrl =
      root.getAttribute('data-blog-url') ||
      location.pathname;

    var shopifyPages =
      parseInt(
        root.getAttribute('data-shopify-pages'),
        10
      ) || 1;

    var list = root.querySelector('[data-blog-articles]');

    if (!list) {
      return Promise.resolve([]);
    }

    var jobs = [];

    for (var p = 1; p <= shopifyPages; p++) {
      jobs.push(fetchPageArticles(blogUrl, p));
    }

    return Promise.all(jobs).then(function (pages) {
      list.innerHTML = '';

      var visible = [];
      var seen = {};

      pages.forEach(function (nodes) {
        nodes.forEach(function (node) {
          if (isHideFromSearchCard(node)) return;

          var id =
            node.getAttribute('data-article-id') ||
            (node.querySelector('a') &&
              node.querySelector('a').href) ||
            '';

          if (id && seen[id]) return;

          if (id) {
            seen[id] = true;
          }

          var el = document.importNode(node, true);

          list.appendChild(el);
          visible.push(el);
        });
      });

      return visible;
    });
  }

  function paginate(root, articles) {
    var perPage =
      parseInt(
        root.getAttribute('data-articles-per-page'),
        10
      ) || PER_PAGE;

    var totalPages = Math.max(
      1,
      Math.ceil(articles.length / perPage)
    );

    var wrap = root.querySelector(
      '[data-blog-pagination]'
    );

    var currentEl = root.querySelector(
      '[data-blog-page-current]'
    );

    var totalEl = root.querySelector(
      '[data-blog-page-total]'
    );

    var prev = root.querySelector(
      '[data-blog-page-prev]'
    );

    var next = root.querySelector(
      '[data-blog-page-next]'
    );

    if (totalEl) {
      totalEl.textContent = String(totalPages);
    }

    if (!articles.length) {
      if (wrap) wrap.hidden = true;
      return;
    }

    if (totalPages <= 1) {
      if (wrap) wrap.hidden = true;

      articles.forEach(function (el) {
        setArticleVisible(el, true);
      });

      return;
    }

    if (wrap) wrap.hidden = false;

    articles.forEach(function (el, i) {
      el.setAttribute(
        'data-page',
        String(Math.floor(i / perPage) + 1)
      );
    });

    var page = getPage();

    if (page > totalPages) {
      page = totalPages;
    }

    if (page < 1) {
      page = 1;
    }

    function show(p, updateUrl) {
      page = p;

      articles.forEach(function (el) {
        var onPage =
          parseInt(
            el.getAttribute('data-page'),
            10
          ) === page;

        setArticleVisible(el, onPage);
      });

      if (currentEl) {
        currentEl.textContent = String(page);
      }

      setDisabled(prev, page <= 1);
      setDisabled(next, page >= totalPages);

      if (prev) {
        prev.href =
          page <= 1
            ? location.pathname
            : '?blog-page=' + (page - 1);
      }

      if (next) {
        next.href =
          page >= totalPages
            ? '?blog-page=' + totalPages
            : '?blog-page=' + (page + 1);
      }

      if (updateUrl) {
        setPage(page);
      }
    }

    if (prev) {
      prev.onclick = function (e) {
        e.preventDefault();

        if (page > 1) {
          show(page - 1, true);

          root.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      };
    }

    if (next) {
      next.onclick = function (e) {
        e.preventDefault();

        if (page < totalPages) {
          show(page + 1, true);

          root.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      };
    }

    show(page, true);
  }

  function init() {
    bindTagFilter();

    var root = document.querySelector(
      '[data-blog-custom-pagination]'
    );

    if (!root) return;

    loadAllPublicPosts(root)
      .then(function (articles) {
        paginate(root, articles);
        root.classList.add('mff-ready');
      })
      .catch(function (err) {
        console.error(
          '[main-blog] load failed',
          err
        );

        var list = root.querySelector(
          '[data-blog-articles]'
        );

        if (!list) {
          root.classList.add('mff-ready');
          return;
        }

        var fallback = Array.prototype.slice.call(
          list.querySelectorAll(
            '[data-blog-article]'
          )
        );

        paginate(root, fallback);
        root.classList.add('mff-ready');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();